module.exports = __webpack_public_path__ + "img/app-mobile-image-3.842d9c7b.png";